
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","d":"M17.93 21.928c-.071 1.248-.853 2.04-1.934 2.04s-1.864-.792-1.934-2.04h3.867zm4.939-1.028H9.123v-.097c.105-.351.694-.975 1.204-1.52.79-.862.94-2.426 1.098-4.272.167-3.26 1.178-4.526 2.707-4.94.255-.07.396-.184.422-.421.062-.905.59-1.573 1.442-1.573s1.38.668 1.441 1.573c.026.237.167.351.422.422 1.53.413 2.54 1.678 2.707 4.94.158 1.845.308 3.41 1.099 4.27.51.546 1.098 1.17 1.204 1.521v.097zm-6.873 4.025c1.713 0 2.935-1.344 2.988-2.997h4.157c.633 0 1.028-.343 1.028-.852 0-.888-.86-1.653-1.6-2.435-.711-.773-.781-2.355-.93-3.735-.141-3.006-1.03-5.063-3.262-5.792-.254-1.178-1.16-2.04-2.381-2.04-1.222 0-2.127.862-2.373 2.04-2.242.73-3.12 2.786-3.27 5.792-.15 1.38-.22 2.962-.932 3.735-.738.782-1.59 1.547-1.59 2.435 0 .51.386.852 1.02.852h4.156c.053 1.644 1.275 2.997 2.989 2.997z","fill-rule":"evenodd"}})])
          )
        }
      }
    